import { formatInstantToPtBR } from '@/shared/lib';
import { resolveIconId } from '@/shared/ui/module-icons';
import type { CreatedModuleResponse, ModuleListItem } from '../api/directories.api';
import type { DirectoryTreeNode } from './types';

export interface ModuleTreeNodeInput {
  id: number;
  name: string;
  iconId?: string | null;
}

export function mapModuleToTreeNode(module: ModuleTreeNodeInput): DirectoryTreeNode {
  const nodeId = `module-${module.id}`;
  const iconId = resolveIconId(module.iconId);

  return {
    id: nodeId,
    name: module.name,
    kind: 'module',
    moduleId: module.id,
    details: {
      title: module.name,
      iconId,
      createdAt: null,
      createdAtLabel: '-',
      createdBy: '-',
      savedInDirectoryBy: '-',
    },
    children: [],
  };
}

export function mapCreatedModuleToTreeNode(
  module: CreatedModuleResponse,
  creatorDisplayName: string
): DirectoryTreeNode {
  const nodeId = `module-${module.id}`;
  const iconId = resolveIconId(module.iconId);

  return {
    id: nodeId,
    name: module.name,
    kind: 'module',
    moduleId: module.id,
    details: {
      title: module.name,
      iconId,
      createdAt: module.createdAt,
      createdAtLabel: formatInstantToPtBR(module.createdAt),
      createdBy: creatorDisplayName,
      savedInDirectoryBy: creatorDisplayName,
    },
    children: [],
  };
}

export function mapListedModuleToTreeNode(module: ModuleListItem): DirectoryTreeNode {
  return mapModuleToTreeNode(module);
}
